import { toNumber } from "lodash";
import { usePeople } from "@/features/people/hooks/usePeople";
import { useTeamDetails } from "./useTeamDetails";
import { Person } from "@/features/people/graphql/generated";
import {
  AssessmentSurveyType,
  AssessmentSurveyConfig,
} from "@/shared/constants/assessmentSurveys";

interface TeamConfig {
  surveys?: AssessmentSurveyConfig[];
  dimensions?: AssessmentSurveyType[];
}

/**
 * Hook to aggregate team profile data including members with filtered survey completion.
 * Extracts available surveys from team config and pre-filters each member's
 * assessment_orders to only include relevant surveys for the team.
 */
export const useTeamProfileData = (teamId: number) => {
  const {
    team,
    loading: loadingTeam,
    error: teamError,
  } = useTeamDetails(teamId);

  const { people, loading: loadingPeople } = usePeople({
    team_id: teamId,
  });

  const teamConfig = (team.config || {}) as TeamConfig;

  // Extract available surveys from team config
  const surveyConfigs = teamConfig.dimensions || [];

  // Filter people to only include actual team members
  // and filter their assessment_orders to only include team-configured surveys
  const teamMembers = people.filter((person: Person) =>
    team.members?.includes(toNumber(person?.id))
  );

  const loading = loadingTeam || loadingPeople;

  return {
    team,
    teamMembers,
    loading,
    error: teamError,
  };
};
